import React from 'react';
import { warnIcon } from './assets';
import { SIGNUP_LINK } from '../../../../../../constants/config';

interface Props {
  isOpen: boolean;
  onClick: () => void;
}

export const CompleteOrderModal: React.FC<Props> = ({
  isOpen = false,
  onClick,
}): JSX.Element => {
  const enterPaymentDetails = () => {
    window.location.href = `${SIGNUP_LINK}/signup/pricing`;
  };

  const clickContactUs = () => {
    // window.open('https://www.substrata.me/contact', '_blank');
    onClick();
  };

  const attrs = {
    wrapper: {
      className: `${isOpen ? '' : 'closed'} complete-order-modal`,
    },

    body: {
      wrapper: {
        className: 'complete-order-modal__body',
      },

      icon: {
        className: 'complete-order-modal__body-warn-icon',
        src: warnIcon,
      },

      title: {
        className: 'complete-order-modal__body-title',
      },

      subtitle: {
        className: 'complete-order-modal__body-subtitle',
      },

      button: {
        className: 'complete-order-modal__body-button',
        onClick: enterPaymentDetails,
      },

      link: {
        className: 'complete-order-modal__body-link',
        onClick: clickContactUs,
      },
    },
  };

  return (
    <div {...attrs.wrapper}>
      <div {...attrs.body.wrapper}>
        <img {...attrs.body.icon} alt="" />
        <div {...attrs.body.title}>Your order was not complete.</div>
        <div {...attrs.body.subtitle}>
          We&apos;re missing some payment details
        </div>
        <div {...attrs.body.button}>Enter payment details</div>
        <div {...attrs.body.link}>Contact us if you have any questions</div>
      </div>
    </div>
  );
};
